const _ = (data: any) => {
  return [
    {
      name: `${data.manufacturerCode}  ${data.productNumber}`,
      id: `${data.manufacturerCode}  ${data.productNumber}`,
      price: data.price || data.partnerPrice,
      brand: data.manufacturerCode,
      position: data.position
    }
  ];
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data.product);
  return {
    event,
    ecommerce: {
      click: {
        actionField: { list: data.list },
        products: [...dataLayerObject]
      }
    }
  };
};
